<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">设备告警记录</v-toolbar-title>
    </v-app-bar>
    <v-content style="background: #eee;">
      <v-container style="padding:0;padding-bottom:2.5rem;">
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
          <div v-if="list.length > 0" style="color:#fff;padding:0.5rem;">
            <div v-for="(item,index) in list" :key="index">
              <NotifyCardF v-if="item.ALERT_TYPE === 'F'" :item="item" flat />
              <NotifyCardT v-else-if="item.ALERT_TYPE === 'T'" :item="item" flat />
              <NotifyCardMsg v-else :item="item" flat />
            </div>
          </div>
          <div v-if="list.length === 0" style="text-align:center;margin-top:10rem;color:#9e9e9e;font-size:0.8rem;">
              暂无相关通知
          </div>
          <div v-else>
            <div style="text-align:center;margin:1.7rem 0 0.5rem;" v-if="hasMore">
              <v-btn color="primary" style="width:10rem;" @click="clickLoadMore">加载更多</v-btn>
            </div>
            <div v-else style="text-align:center;font-size:0.8rem;color:#9e9e9e;margin-top:1.7rem;">
              没有更多数据!
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>

</template>

<script>
import LoadingText from '../../components/LoadingText'
// import NotifyCard from './components/NotifyCard.vue'
import NotifyCardF from './components/NotifyCardF_v3'
import NotifyCardT from './components/NotifyCardT_v3'
import NotifyCardMsg from './components/NotifyCardMsg'
export default {
  components: { LoadingText, /* NotifyCard*/ NotifyCardF, NotifyCardT, NotifyCardMsg },
  props: {
  },
  data() {
    return {
      loading: true,
      list: [],
      pageIndex: 1,
      pageCount: 10,
      hasMore: true
    }
  },
  computed: {
  },
  mounted() {
    // this.getList()
  },
  created() {
  },
  activated() {
    var that = this
    if (!that.$router.isBack) {
      that.getList()
    }
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    goDetail(item) {
      var that = this
      that.$api.bz.setDeviceNotifyRead({ code: item.NOTIFY_CODE }).then(res => {
        item.READ_SID = 2;
        // that.$router.goPage('/AlertContent/' + item.ALERT_RECORD_CODE + '?has_back=true')
        that.$router.goPage('/AlertContentV3/' + item.NOTIFY_CODE + '?has_back=true')
      })
    },
    async getList() {
      var that = this
      if (that.pageIndex === 1) {
        that.list = []
        that.loading = true
      }
      var res = await that.$api.bz.getDeviceNotifyList({ page_index: that.pageIndex, page_count: that.pageCount })
      if (!res.success) {
        console.log('获取通知列表失败', res);
        that.loading = false
        return;
      }
      var data = res.data
      if (data.length == 0) {
        that.loading = false
        that.hasMore = false;
        return;
      }
      that.hasMore = data.length >= that.pageCount;
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        console.log(item)
        that.list.push(item);
      }
      that.loading = false
    },
    // 格式化时间显示
    getMsgTimeFormat(time) {
      var that = this
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY-MM-DD HH:mm')
      }
      return mt.format('今天 HH:mm')
    },
    clickLoadMore() {
      var that = this
      that.pageIndex++;
      that.getList();
    },
    formatVal(item) {
      return item.alert_info.CUR_VALUE.toFixed(item.alert_info.VALIE_DIGITS)
    },
    // 时间格式化
    getDuraStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}

</style>

